import { inventoryPackagesToServiceV2 } from "../inventoryPackage";
import { PUBLISHER_SETTINGS_ORIGIN } from "./publisher";
import { getIncludedBundles, getIncludedChannels, pubCapPctToServicePubCap, servicePubCapObjectToPubCapPct } from "./utils";
export const servicePublisherRollupToPublisherRollup = (servicePublisherRollupResponse) => {
    return {
        // API does not return the Template ID or Inventory Packages.
        templateId: undefined,
        inventoryPackagesV2: undefined,
        publisherSettings: servicePublisherRollupResponse?.pub_settings?.map((pubSetting) => ({
            publisherId: pubSetting.pub_id,
            publisherName: pubSetting.pub_name,
            pubCapPct: servicePubCapObjectToPubCapPct(pubSetting.pub_cap),
            sources: pubSetting.sources,
            bundleRules: pubSetting.excluded_bundles?.map((bundle) => ({
                id: bundle.bundle_id,
                excluded: bundle.excluded ?? true, // the FE tracks the excluded key to display bundles in the roll up table, defaults to true.
                origin: bundle.excluded_origin
            })) || [],
            channelRules: pubSetting.excluded_channels?.map((channel) => ({
                name: channel.channel_name,
                excluded: channel.excluded ?? true, // the FE tracks the excluded key to display channels in the roll up table, defaults to true.
                origin: channel.excluded_origin
            })) || [],
            includedBundles: pubSetting.included_bundles?.map((bundle) => ({
                id: bundle.bundle_id,
                origin: bundle.excluded_origin
            })) || [],
            includedChannels: pubSetting.included_channels?.map((channel) => ({
                name: channel.channel_name,
                origin: channel.excluded_origin
            })) || []
        }))
    };
};
export const publisherRollupToServicePublisherRollupRequest = (publisherRollup) => {
    const user_edits = publisherRollup?.publisherSettings?.reduce((userEdits, pubSetting) => {
        // Only send publisher settings objects that have a value different from default.
        if (!pubSetting.bundleRules.length &&
            !pubSetting.channelRules.length &&
            !pubSetting.includedBundles.length &&
            !pubSetting.includedChannels.length &&
            (pubSetting.pubCapPct === null || pubSetting.pubCapPct === undefined)) {
            return userEdits;
        }
        const servicePubCapPct = pubCapPctToServicePubCap(pubSetting.pubCapPct);
        const pub_cap = servicePubCapPct !== undefined ? { pub_cap_pct: servicePubCapPct } : undefined;
        // Extract bundles/channels that are explicitly excluded (excluded: true)
        const excluded_bundles = pubSetting.bundleRules
            ?.filter((rule) => rule.excluded)
            .map((bundleRule) => ({
            bundle_id: bundleRule.id,
            excluded_origin: bundleRule.origin || PUBLISHER_SETTINGS_ORIGIN.TEMPLATE,
            excluded: true
        }));
        const excluded_channels = pubSetting.channelRules
            ?.filter((rule) => rule.excluded)
            .map((channelRule) => ({
            channel_name: channelRule.name,
            excluded_origin: channelRule.origin || PUBLISHER_SETTINGS_ORIGIN.TEMPLATE,
            excluded: true
        }));
        // When a user removes a bundle/channel from the exclusion list in the UI,
        // we track it as "re-included" (excluded: false) to maintain history.
        // These re-included items are stored in the included_bundles/included_channels arrays
        // sent to the API, allowing the backend to know which items were previously excluded
        // but are now allowed again.
        const included_bundles = getIncludedBundles(pubSetting.bundleRules, pubSetting.includedBundles);
        const included_channels = getIncludedChannels(pubSetting.channelRules, pubSetting.includedChannels);
        userEdits.push({
            pub_id: pubSetting.publisherId,
            pub_name: pubSetting.publisherName,
            sources: pubSetting.sources || [],
            ...(pub_cap ? { pub_cap } : {}),
            ...(excluded_bundles?.length ? { excluded_bundles } : {}),
            ...(excluded_channels?.length ? { excluded_channels } : {}),
            ...(included_bundles?.length ? { included_bundles } : {}),
            ...(included_channels?.length ? { included_channels } : {})
        });
        return userEdits;
    }, []);
    return {
        id: publisherRollup?.id,
        template_id: publisherRollup?.templateId,
        inventory_packages_v2: inventoryPackagesToServiceV2(publisherRollup?.inventoryPackagesV2),
        // API responds with 500 if empty user_edits array is sent.
        user_edits: user_edits?.length ? user_edits : undefined
    };
};
//# sourceMappingURL=publisherRollup.js.map